import React, { useState } from "react";
import styles from "./QuotationList.module.scss";
import { connect } from "react-redux";
import Breadcrumbs from "../../UI/Breadcrumbs/Breadcrumbs.tsx";
import RegisteredUserProfileLoader from "../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";
import EmptyState from "../../UI/EmptyState/EmptyState";
import { ReactComponent as NoResultsIcon } from "../../../assets/svg/NoResultsMagnifier.svg";
import Pagination from "../../../hooks/pagination";
import { clearProjects } from "../../../store/actions";
import FilterQuotation from "../../Filters/FilterQuotations/FilterQuotation.tsx";

const QuotationList = ({
  quotations,
  setSelectedOption,
  selectedOption,
  isLoading,
}) => {
  const [isFiltered, setIsFiltered] = useState(false);
  const pageNumberLimit = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);

  const paginationAttributes = {
    currentPage,
    maxPageLimit,
    minPageLimit,
    response: quotations,
  };

 const onPageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

  const onPrevClick = () => {
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageLimit(maxPageLimit - pageNumberLimit);
      setMinPageLimit(minPageLimit - pageNumberLimit);
    }
    setCurrentPage((prev) => prev - 1);
  };

  const onNextClick = () => {
    if (currentPage + 1 > maxPageLimit) {
      setMaxPageLimit(maxPageLimit + pageNumberLimit);
      setMinPageLimit(minPageLimit + pageNumberLimit);
    }
    setCurrentPage((prev) => prev + 1);
  };

  const totalPage = Math.ceil((quotations?.itemCount ?? 0) / (quotations?.take || 9)) || 1;
  const onPrevWindow = () => {
    const newMin = Math.max(0, minPageLimit - pageNumberLimit);
    const newMax = minPageLimit;
    const targetPage = newMin + 1;
    setCurrentPage(targetPage);
    setMaxPageLimit(newMax);
    setMinPageLimit(newMin);
  };
  const onNextWindow = () => {
    const targetPage = Math.min(totalPage, maxPageLimit + 1);
    setCurrentPage(targetPage);
    const newMin = maxPageLimit;
    const newMax = Math.min(totalPage, maxPageLimit + pageNumberLimit);
    setMaxPageLimit(newMax);
    setMinPageLimit(newMin);
  };

  const quotationCount = quotations?.entities?.length || 0;

  return (
      <div className={styles.containerList}>
        <div className={styles.breadcrumbContainer}>
          <Breadcrumbs />
        </div>
        <div className={styles.list}>
          <FilterQuotation 
            setIsFiltered={setIsFiltered} 
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSelectedOption={setSelectedOption}
            quotationCount={quotationCount}
            selectedOption={selectedOption} />
          {isLoading ? (
            <div className={styles.loadingContainer}>
            <RegisteredUserProfileLoader />
            </div>
          ) : (
            <div className={styles.cotizacionDeMaterialesContainer}>
              {!(quotations?.entities?.length) ? (
                <div className={styles.emptyState}>
                  <EmptyState title="No hay resultados para su búsqueda" icon={<NoResultsIcon width={80} height={80} />} />
                </div>
              ) : (
                <Pagination
                  {...paginationAttributes}
                  onPrevClick={onPrevClick}
                  onNextClick={onNextClick}
                  onPageChange={onPageChange}
                  onPrevWindow={onPrevWindow}
                  onNextWindow={onNextWindow}
                  isQuotation
                />
              )}
            </div>
          )}
        </div>

      </div>
  );

};

const mapStateToProps = (state) => ({
  quotations: state.profile.quotations,
  isLoading: state.dashboard.loading || false,
});

export default connect(mapStateToProps, {
  clearProjects,
})(QuotationList);
